import { isGlobalworth } from 'config'

enum BookingPaths {
  PARKING_SPOTS = '/booking/parking-spots',
  CONFERENCE_ROOMS = '/booking/conference-rooms',
  DESKS = '/booking/desks',
  LOCKERS = '/booking/lockers',
  OTHER = '/booking/other',
  SAUNAS = '/booking/saunas',
}

const isBookingPath = (pathname: string) => {
  const paths = Object.values(BookingPaths)

  if (!isGlobalworth) {
    return paths
      .filter(path => path !== BookingPaths.LOCKERS)
      .some(path => pathname.startsWith(path))
  }

  return paths
    .filter(
      path => path !== BookingPaths.OTHER && path !== BookingPaths.SAUNAS
    )
    .some(path => pathname.startsWith(path))
}

export { BookingPaths, isBookingPath }
